import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page85() {
  useEffect(() => {
    document.title = "Маяк — Страница 84"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page83" />
        <ForwardLink href="/page85" />
      </div>

      <p style={{ textAlign: "right" }}>84.</p>
      <p>
        МОЛОДОЙ прямо позади СТАРИКА... с ЗАЖЖЕННОЙ СПИЧКОЙ... совершенно<br/>
        неподвижный. Все еще жуткий.
      </p>
      <p>Он спокойно зажигает ТРУБКУ СТАРИКА.</p>
      <p>СТАРИКУ немного не по себе.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Благодарю.
      </p>
      <p>Пауза.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Что с твоей рукой?
      </p>
      <p>МОЛОДОЙ в замешательстве смотрит на руку со спичкой.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        С другой.
      </p>
      <p>МОЛОДОЙ смотрит: его левая рука оставляет следы крови на столе.</p>
      <p>Он убирает порезанную руку.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Ты слышал о столбняке?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        --
      </p>
      <p style={{ display: "flex" }}>
        <div>
          <div style={{ textAlign: "center" }}>СТАРИК</div>
          Столб-ня-ке?
        </div>
        <div style={{ marginLeft: "auto" }}>
          <div style={{ textAlign: "center" }}>МОЛОДОЙ (ПРОДОЛЖЕНИЕ)</div>
          <div style={{ textAlign: "center" }}>(тихо, жестко)</div>
          Да.
        </div>
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Все началось с небольшого пореза, вот<br/>
        и все...
      </p>
      <p>МОЛОДОЙ неподвижен. Кипит.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Я сказал, я слышал об этом.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        ... от фор-стакселя, когда<br/>
        мы отплыли...
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Ты никогда не можешь заткнуться.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        ... но проходит полмесяца...
      </p>
      <p style={{ textAlign: "right" }}>84.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page83" />
        <ForwardLink href="/page85" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710717635/the-lighthouse-script/mchocbfctjf45lhrbs8g.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page85;
